// removed by extract-text-webpack-plugin
module.exports = {"root":"_2Ye-w"};